import { Directive, TemplateRef } from '@angular/core';

@Directive({selector: '[appQueryButtonGroup]'})
export class QueryButtonGroupDirective {
  constructor(public template: TemplateRef<any>) {}
}
